/**
 * Text formatting utilities shared across list item components.
 */

/**
 * Truncate text to a maximum length, appending an ellipsis when truncated.
 */
export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) {
    return text;
  }
  return `${text.substring(0, maxLength)}...`;
};
